export const GET_MARKETING_QUESTIONS = 'innovA/settings#getMarketingQuestions';
export const SAVE_MARKETING_QUESTION_RESPONSE = 'innovA/settings#saveMarketingQuestionResponse';
export const GET_STOCK_NUMBER_USED = 'innovA/settings#getStockNumberUsed';
export const LOADING_STOCK_NUMBER = 'innovA/watchlist#loadingStockNumber';